import { defineMessages } from 'react-intl';

export default defineMessages({
  loadingMessage: {
    id: 'components.atom.placeAutcomplete.loadingMessage',
    defaultMessage: 'Loading...',
  },
});
